import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ArrowDownIcon } from "../assets/arrow.svg";
import { ReactComponent as NewbieIcon } from "../assets/toupgrade/icon1.svg";
import { ReactComponent as PhysicalIcon } from "../assets/toupgrade/icon2.svg";
import { ReactComponent as MentalIcon } from "../assets/toupgrade/icon3.svg";
import { ReactComponent as SpiritualIcon } from "../assets/toupgrade/icon4.svg";
import { ReactComponent as CareerIcon } from "../assets/toupgrade/icon5.svg";
import { ReactComponent as StorageIcon } from "../assets/toupgrade/icon6.svg";
import Header from './Header';

const Upgrade = React.memo(() => {
    const navigate = useNavigate();

    const handleUpgradeSelect = (title) => {
        if (title === 'Полезные материалы') {
            navigate(`/upgrade/${encodeURIComponent(title)}`);
        } else {
            navigate(`/upgrade/${encodeURIComponent(title)}/detail/${encodeURIComponent(title)}`);
        }
    };

    return (
        <>
            <Header />
            <div className="upgrade-content">
                <div className="upgrade-header-wrapper">
                    <div className="upgrade-header-glow"></div>
                    <div className="upgrade-header-block">
                        <h1 className="upgrade-main-title">АПГРЕЙД</h1>
                        <p className="upgrade-subtitle">Информационный раздел</p>
                        <div className="arrow-container">
                            <ArrowDownIcon className="arrow-down-animated" />
                        </div>
                    </div>
                </div>

                <div className="list-buttons">
                    <button className="list-btn" onClick={() => handleUpgradeSelect('Полезные материалы')}>
                        <div className="btn-icon">
                            <NewbieIcon />
                        </div>
                        <span className="btn-text">Полезные материалы</span>
                        <span className="btn-open">Открыть</span>
                    </button>
                    <button className="list-btn" onClick={() => handleUpgradeSelect('Инструкция для новичка')}>
                        <div className="btn-icon">
                            <PhysicalIcon />
                        </div>
                        <span className="btn-text">Инструкция для новичка</span>
                        <span className="btn-open">Открыть</span>
                    </button>
                    <button className="list-btn" onClick={() => handleUpgradeSelect('Правила марафона')}>
                        <div className="btn-icon">
                            <MentalIcon />
                        </div>
                        <span className="btn-text">Правила марафона</span>
                        <span className="btn-open">Открыть</span>
                    </button>
                    <button className="list-btn" onClick={() => handleUpgradeSelect('Регламент сдачи отчётов')}>
                        <div className="btn-icon">
                            <SpiritualIcon />
                        </div>
                        <span className="btn-text">Регламент сдачи отчётов</span>
                        <span className="btn-open">Открыть</span>
                    </button>
                    <button className="list-btn" onClick={() => handleUpgradeSelect('Регламент общения в чате')}>
                        <div className="btn-icon">
                            <CareerIcon />
                        </div>
                        <span className="btn-text">Регламент общения в чате</span>
                        <span className="btn-open">Открыть</span>
                    </button>
                    <button className="list-btn" onClick={() => handleUpgradeSelect('Условия розыгрыша')}>
                        <div className="btn-icon">
                            <StorageIcon />
                        </div>
                        <span className="btn-text">Условия розыгрыша</span>
                        <span className="btn-open">Открыть</span>
                    </button>
                </div>
            </div>
        </>
    );
});

export default Upgrade;
